function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2020(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 19.26,
    height: 8.74,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.0925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 4.37,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.74,
    width: 19.26,
    height: 9.13,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5216666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 13.305,
    fontFamily: "Arial"
  }, "\n        Norton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 17.88,
    width: 19.26,
    height: 13.58,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 24.669999999999998,
    fontFamily: "Arial"
  }, "\n        Emporia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.46,
    width: 19.26,
    height: 14.27,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 38.595,
    fontFamily: "Arial"
  }, "\n        Bath\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.73,
    width: 19.26,
    height: 14.85,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 53.154999999999994,
    fontFamily: "Arial"
  }, "\n        Covington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.58,
    width: 19.26,
    height: 15.05,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 68.105,
    fontFamily: "Arial"
  }, "\n        Galax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 75.62,
    width: 19.26,
    height: 15.76,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.751111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 83.5,
    fontFamily: "Arial"
  }, "\n        Lexington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.38,
    width: 19.26,
    height: 15.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.44
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 99.3,
    fontFamily: "Arial"
  }, "\n        Buena_Vista\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 107.21,
    width: 19.26,
    height: 18.08,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6159999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 116.25,
    fontFamily: "Arial"
  }, "\n        Craig\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 125.29,
    width: 19.26,
    height: 19.85,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8520000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 135.215,
    fontFamily: "Arial"
  }, "\n        Bland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 145.14,
    width: 19.26,
    height: 23.15,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.4815384615384617
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 156.71499999999997,
    fontFamily: "Arial"
  }, "\n        Franklin_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 168.29,
    width: 19.26,
    height: 23.4,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 179.98999999999998,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.69,
    width: 19.26,
    height: 23.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.375714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 203.425,
    fontFamily: "Arial"
  }, "\n        King_and_Queen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 215.16,
    width: 19.26,
    height: 25.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6050000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 227.825,
    fontFamily: "Arial"
  }, "\n        Charles_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 240.49,
    width: 19.26,
    height: 25.5,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8520000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 253.24,
    fontFamily: "Arial"
  }, "\n        Surry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 266,
    width: 19.26,
    height: 26.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.750909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 279.045,
    fontFamily: "Arial"
  }, "\n        Greensville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 292.09,
    width: 19.26,
    height: 28.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6050000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 306.28999999999996,
    fontFamily: "Arial"
  }, "\n        Rappahannock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 320.49,
    width: 19.26,
    height: 29.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2100000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 335,
    fontFamily: "Arial"
  }, "\n        Sussex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 349.51,
    width: 19.26,
    height: 30.29,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9260000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 364.655,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 379.8,
    width: 19.26,
    height: 33.23,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.751428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 396.415,
    fontFamily: "Arial"
  }, "\n        Mathews\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 413.03,
    width: 19.26,
    height: 34.23,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 430.145,
    fontFamily: "Arial"
  }, "\n        Lunenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 447.26,
    width: 19.26,
    height: 34.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.6050000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 464.40999999999997,
    fontFamily: "Arial"
  }, "\n        Martinsville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 481.56,
    width: 19.26,
    height: 34.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4815384615384617
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 498.92,
    fontFamily: "Arial"
  }, "\n        Manassas_Park\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 516.28,
    width: 19.26,
    height: 35.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8520000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 533.9,
    fontFamily: "Arial"
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 551.53,
    width: 19.26,
    height: 35.32,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 569.1899999999999,
    fontFamily: "Arial"
  }, "\n        Charlotte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 586.84,
    width: 19.26,
    height: 36.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.751428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 604.865,
    fontFamily: "Arial"
  }, "\n        Radford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 622.89,
    width: 19.26,
    height: 38.4,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.750909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 642.09,
    fontFamily: "Arial"
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 661.3,
    width: 19.26,
    height: 38.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 9.63,
    y: 680.65,
    fontFamily: "Arial"
  }, "\n        Middlesex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 0,
    width: 25.48,
    height: 29.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1233333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 32,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Williamsburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.74,
    y: 0,
    width: 26.2,
    height: 29.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 57.84,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Nottoway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.94,
    y: 0,
    width: 26.47,
    height: 29.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.941111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 84.175,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Lancaster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.41,
    y: 0,
    width: 27.03,
    height: 29.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0033333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.925,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Dickenson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.44,
    y: 0,
    width: 28.9,
    height: 29.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.128571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.89,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Bristol\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 153.34,
    y: 0,
    width: 28.93,
    height: 29.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.0664285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.805,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Northumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.27,
    y: 0,
    width: 29.08,
    height: 29.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.635
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.81,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Poquoson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 211.35,
    y: 0,
    width: 29.22,
    height: 29.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.95999999999998,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Amelia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 240.57,
    y: 0,
    width: 29.42,
    height: 29.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.268888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.28,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Brunswick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 269.99,
    y: 0,
    width: 30.08,
    height: 29.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.968
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.03000000000003,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Buckingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.07,
    y: 0,
    width: 30.09,
    height: 29.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.115,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.16,
    y: 0,
    width: 30.1,
    height: 29.68,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.21000000000004,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Grayson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 360.26,
    y: 0,
    width: 30.36,
    height: 29.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2977777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.44,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Alleghany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.62,
    y: 0,
    width: 32.64,
    height: 29.68,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.473333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 406.94,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Falls_Church\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 423.27,
    y: 0,
    width: 33.86,
    height: 29.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.855
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.2,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Colonial_Heights\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 457.12,
    y: 0,
    width: 33.97,
    height: 29.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.936
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 474.105,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Giles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.09,
    y: 0,
    width: 34.31,
    height: 29.68,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.968
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.245,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Appomattox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.4,
    y: 0,
    width: 34.48,
    height: 29.68,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.946666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 542.64,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Nelson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.88,
    y: 0,
    width: 34.56,
    height: 29.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.946666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 577.16,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.44,
    y: 0,
    width: 34.83,
    height: 29.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.936
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 611.855,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 629.27,
    y: 0,
    width: 35.29,
    height: 29.68,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 646.915,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Patrick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 664.56,
    y: 0,
    width: 35.44,
    height: 29.68,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2830769230769232
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 682.28,
    y: 14.84,
    fontFamily: "Arial"
  }, "\n        Prince_Edward\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 29.68,
    width: 36.69,
    height: 28.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.59625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 44.065,
    fontFamily: "Arial"
  }, "\n        Hopewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 58.44,
    width: 36.69,
    height: 29.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6636363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 73.09,
    fontFamily: "Arial"
  }, "\n        Southampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 87.75,
    width: 36.69,
    height: 29.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.478333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 102.62,
    fontFamily: "Arial"
  }, "\n        Westmoreland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 117.49,
    width: 36.69,
    height: 29.78,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.926666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 132.38,
    fontFamily: "Arial"
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 147.27,
    width: 36.69,
    height: 29.8,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 162.17000000000002,
    fontFamily: "Arial"
  }, "\n        Buchanan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 177.07,
    width: 36.69,
    height: 32.09,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.2090000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 193.115,
    fontFamily: "Arial"
  }, "\n        Waynesboro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 209.15,
    width: 36.69,
    height: 32.15,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6791666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 225.225,
    fontFamily: "Arial"
  }, "\n        King_William\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 241.3,
    width: 36.69,
    height: 32.54,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.508
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 257.57,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 273.84,
    width: 36.69,
    height: 33.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 290.775,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 307.71,
    width: 36.69,
    height: 36.25,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 325.835,
    fontFamily: "Arial"
  }, "\n        Winchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 343.96,
    width: 36.69,
    height: 37.05,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6689999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 362.48499999999996,
    fontFamily: "Arial"
  }, "\n        Rockbridge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 381,
    width: 36.69,
    height: 37.47,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.1725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 399.735,
    fontFamily: "Arial"
  }, "\n        Page\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 418.47,
    width: 36.69,
    height: 38.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6207142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 437.725,
    fontFamily: "Arial"
  }, "\n        Fredericksburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 456.98,
    width: 36.69,
    height: 38.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.58625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 476.425,
    fontFamily: "Arial"
  }, "\n        Staunton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 495.88,
    width: 36.69,
    height: 39.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.337999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 515.42,
    fontFamily: "Arial"
  }, "\n        Salem\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 534.95,
    width: 36.69,
    height: 40.08,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.241428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 554.99,
    fontFamily: "Arial"
  }, "\n        Russell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 575.03,
    width: 36.69,
    height: 40.37,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0574999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 595.2149999999999,
    fontFamily: "Arial"
  }, "\n        Fairfax_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 615.4,
    width: 36.69,
    height: 42.27,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6689999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 636.535,
    fontFamily: "Arial"
  }, "\n        Petersburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.26,
    y: 657.67,
    width: 36.69,
    height: 42.33,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.337999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.605000000000004,
    y: 678.8349999999999,
    fontFamily: "Arial"
  }, "\n        Smyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 29.68,
    width: 37.89,
    height: 41.24,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.444545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 74.89500000000001,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        King_George\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.83,
    y: 29.68,
    width: 38.52,
    height: 41.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 113.09,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        New_Kent\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.36,
    y: 29.68,
    width: 40.15,
    height: 41.24,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.03
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.435,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Wythe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.5,
    y: 29.68,
    width: 40.2,
    height: 41.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.466666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 192.6,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Dinwiddie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.7,
    y: 29.68,
    width: 41.69,
    height: 41.24,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8914285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.545,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.39,
    y: 29.68,
    width: 42.19,
    height: 41.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.485,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Fluvanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.58,
    y: 29.68,
    width: 43.16,
    height: 41.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7490909090909095
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.15999999999997,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Mecklenburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.74,
    y: 29.68,
    width: 43.39,
    height: 41.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.435,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Caroline\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 383.13,
    y: 29.68,
    width: 44.26,
    height: 41.24,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.26,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Wise\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.39,
    y: 29.68,
    width: 45.15,
    height: 41.24,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.582222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.965,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Goochland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.53,
    y: 29.68,
    width: 45.18,
    height: 41.24,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.11999999999995,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Accomack\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.71,
    y: 29.68,
    width: 45.2,
    height: 41.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 540.3100000000001,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Manassas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.91,
    y: 29.68,
    width: 45.29,
    height: 41.24,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8914285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.555,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Amherst\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.21,
    y: 29.68,
    width: 45.51,
    height: 41.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.436666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.965,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Harrisonburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 653.72,
    y: 29.68,
    width: 46.28,
    height: 41.24,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8914285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.86,
    y: 50.3,
    fontFamily: "Arial"
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 70.92,
    width: 47.76,
    height: 40.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0846153846153848
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 90.97,
    fontFamily: "Arial"
  }, "\n        Prince_George\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 111.02,
    width: 47.76,
    height: 41.97,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.9957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 132.005,
    fontFamily: "Arial"
  }, "\n        Halifax\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 152.99,
    width: 47.76,
    height: 44.6,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 175.29000000000002,
    fontFamily: "Arial"
  }, "\n        Danville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 197.59,
    width: 47.76,
    height: 45.38,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.6725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 220.28,
    fontFamily: "Arial"
  }, "\n        Powhatan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 242.97,
    width: 47.76,
    height: 46.31,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.78875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 266.125,
    fontFamily: "Arial"
  }, "\n        Tazewell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 289.29,
    width: 47.76,
    height: 47.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.951666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 313.14500000000004,
    fontFamily: "Arial"
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 337,
    width: 47.76,
    height: 48.58,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 361.29,
    fontFamily: "Arial"
  }, "\n        Botetourt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 385.58,
    width: 47.76,
    height: 48.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 409.9,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 434.22,
    width: 47.76,
    height: 50.41,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.96
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 459.425,
    fontFamily: "Arial"
  }, "\n        Louisa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 484.63,
    width: 47.76,
    height: 51.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.776
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 510.255,
    fontFamily: "Arial"
  }, "\n        Gloucester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 535.89,
    width: 47.76,
    height: 53.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6738461538461538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 562.865,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 589.84,
    width: 47.76,
    height: 54.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.776
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 617.08,
    fontFamily: "Arial"
  }, "\n        Shenandoah\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.95,
    y: 644.32,
    width: 47.76,
    height: 55.68,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1839999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.83,
    y: 672.1600000000001,
    fontFamily: "Arial"
  }, "\n        Charlottesville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 70.92,
    width: 46.26,
    height: 61.99,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.251999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.83,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.97,
    y: 70.92,
    width: 48.05,
    height: 61.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.00625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.995,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Culpeper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.02,
    y: 70.92,
    width: 50.83,
    height: 61.99,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.083
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.435,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.85,
    y: 70.92,
    width: 52.64,
    height: 61.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.509333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.17,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 301.49,
    y: 70.92,
    width: 52.97,
    height: 61.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.62125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.975,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.47,
    y: 70.92,
    width: 60.66,
    height: 61.99,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.8,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Pittsylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 415.12,
    y: 70.92,
    width: 64.44,
    height: 61.99,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.887777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 447.34000000000003,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Lynchburg\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.56,
    y: 70.92,
    width: 68.74,
    height: 61.99,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.4975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 513.93,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 548.3,
    y: 70.92,
    width: 74.92,
    height: 61.99,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.855714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.76,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Augusta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.22,
    y: 70.92,
    width: 76.78,
    height: 61.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.1658333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.61,
    y: 101.915,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 132.91,
    width: 72.4,
    height: 66.25,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.28125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.9,
    y: 166.035,
    fontFamily: "Arial"
  }, "\n        Fauquier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 199.16,
    width: 72.4,
    height: 66.48,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.648000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.9,
    y: 232.4,
    fontFamily: "Arial"
  }, "\n        Rockingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 265.64,
    width: 72.4,
    height: 67.65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.765000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.9,
    y: 299.465,
    fontFamily: "Arial"
  }, "\n        Portsmouth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 333.28,
    width: 72.4,
    height: 68.34,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.8340000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.9,
    y: 367.45,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 401.62,
    width: 72.4,
    height: 73.85,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.342857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.9,
    y: 438.545,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 475.47,
    width: 72.4,
    height: 73.9,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.044444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.9,
    y: 512.4200000000001,
    fontFamily: "Arial"
  }, "\n        Frederick\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 549.38,
    width: 72.4,
    height: 75.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.24
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.9,
    y: 587.03,
    fontFamily: "Arial"
  }, "\n        James_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.7,
    y: 624.67,
    width: 72.4,
    height: 75.33,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.342857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.9,
    y: 662.3349999999999,
    fontFamily: "Arial"
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.1,
    y: 132.91,
    width: 72.43,
    height: 86.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.173571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.315,
    y: 176.28,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.52,
    y: 132.91,
    width: 81.89,
    height: 86.74,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.098888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 289.46500000000003,
    y: 176.28,
    fontFamily: "Arial"
  }, "\n        Albemarle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.41,
    y: 132.91,
    width: 83.47,
    height: 86.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.924285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.14500000000004,
    y: 176.28,
    fontFamily: "Arial"
  }, "\n        Hampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.88,
    y: 132.91,
    width: 89.88,
    height: 86.74,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.391428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.82,
    y: 176.28,
    fontFamily: "Arial"
  }, "\n        Hanover\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 503.76,
    y: 132.91,
    width: 95.39,
    height: 86.74,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.228333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.455,
    y: 176.28,
    fontFamily: "Arial"
  }, "\n        Spotsylvania\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.15,
    y: 132.91,
    width: 100.85,
    height: 86.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.8425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.5749999999999,
    y: 176.28,
    fontFamily: "Arial"
  }, "\n        Stafford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.1,
    y: 219.64,
    width: 112.48,
    height: 79.3,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.34,
    y: 259.28999999999996,
    fontFamily: "Arial"
  }, "\n        Newport_News\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.1,
    y: 298.95,
    width: 112.48,
    height: 80.58,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.058
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.34,
    y: 339.24,
    fontFamily: "Arial"
  }, "\n        Alexandria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.1,
    y: 379.52,
    width: 112.48,
    height: 87.78,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.540000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.34,
    y: 423.40999999999997,
    fontFamily: "Arial"
  }, "\n        Norfolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.1,
    y: 467.3,
    width: 112.48,
    height: 108.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.350769230769231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.34,
    y: 521.58,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 176.1,
    y: 575.86,
    width: 112.48,
    height: 124.14,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.248000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.34,
    y: 637.9300000000001,
    fontFamily: "Arial"
  }, "\n        Chesapeake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.58,
    y: 219.64,
    width: 103.86,
    height: 138.24,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.51,
    y: 288.76,
    fontFamily: "Arial"
  }, "\n        Arlington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392.44,
    y: 219.64,
    width: 145.54,
    height: 138.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.74857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.21,
    y: 288.76,
    fontFamily: "Arial"
  }, "\n        Henrico\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 537.98,
    y: 219.64,
    width: 162.02,
    height: 138.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.520000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 618.99,
    y: 288.76,
    fontFamily: "Arial"
  }, "\n        Chesterfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.58,
    y: 357.88,
    width: 145.27,
    height: 170.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.752857142857145
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.215,
    y: 442.9,
    fontFamily: "Arial"
  }, "\n        Loudoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.58,
    y: 527.92,
    width: 145.27,
    height: 172.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.376428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.215,
    y: 613.9599999999999,
    fontFamily: "Arial"
  }, "\n        Virginia_Beach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.85,
    y: 357.88,
    width: 266.15,
    height: 94.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.723571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.925,
    y: 404.945,
    fontFamily: "Arial"
  }, "\n        Prince_William\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.85,
    y: 452.01,
    width: 266.15,
    height: 247.99,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.71357142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.925,
    y: 576.005,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2020);
export default __webpack_public_path__ + "static/media/2020.29e89e376034f7f285f6dd40c6d0f307.svg";
export { ForwardRef as ReactComponent };